export class AlertOne {
    clear() {
       
    }
}
